export const masks = {
  cnpj: '**.***.***/****-99',
  cpfForCnpj: '***.***.***-**',
  cpf: '999.999.999-99',
  numPedido: '999999',
  numPedAllied: '999999999',
  numPedEcom: '999999999',
  numNota: '9999999',
  telefone: '(99) 99999-9999',
  cep: '99999-999',
} as const;
